/*

jvDatepicker
============

jquery ui datepicker

Multiselect Datepicker Usage
============
Requires multidatepicker.js
_multiselectdatepicker.scss

<div ng-model="dates" jv-datepicker="datepickerOptions" class="multiDatepicker"></div>

        Set this object in the controller
        datepickerOptions = {
            multiSelect: true,
            numberOfMonths: [1,2]  //This is a range months 1 through 2
            dateFormat: mm/dd/yy , mm:dd:yy , mm-dd-yy, dd/mm/yy
            timeInMilli: true/false coverts all the dates in milliseconds if set to true
        };
    selected dates are stored back in object provided in ngModel
 */
angular.module('jv.Common.Directives.Datepicker', [])

.directive('jvDatepicker', function(){
    return {
        require: 'ngModel',
        link: function(scope, iElm, iAttrs, ngModel) {
            var options = angular.extend({
                dateFormat: 'yy-mm-dd',
                onSelect: function(date){
                    scope.$apply(function() {
                        ngModel.$setViewValue(date);
                    });
                }
            }, scope.$eval(iAttrs.jvDatepicker) || {});

            //multiselect date picker
            if(options.multiSelect){
                $(iElm).multiDatesPicker({
                    numberOfMonths: options.numberOfMonths,
                    maxPicks: options.maxPicks,
                    dateFormat: options.dateFormat,
                    //This is fired when a date is seleted
                    onSelect : function(){
                        scope.$apply(function(){
                            //datesPicked holds all the dates that were clicked
                            var datesPicked = $(iElm).multiDatesPicker('getDates');
                            if(options.timeInMilli){
                                //converting all the dates to milliseconds
                                angular.forEach(datesPicked,function(datePicked,key){
                                    var date = new Date(datePicked);
                                    var timeInMilli = date.getTime();
                                    datesPicked[key] = timeInMilli;
                                });
                            }
                            ngModel.$setViewValue(datesPicked);
                        });
                    }
                });
            }else{
                //regular datepicker
                
                $(iElm).datepicker(options);
                scope.$watch(iAttrs.jvDatepicker, function(opts) {
                    $(iElm).datepicker('option', opts);
                }, true);
            }

        }
    };
})

.directive('jvLocaleDatepicker',['$window', '$rootScope','$timeout', '$parse', function($window, $rootScope, $timeout, $parse){
     return {
        require: 'ngModel',
        link: function(scope, iElm, iAttrs, ngModel) {
            //Format in which the data will be stored in ngModel. Default is short ISO format. This can be overwritten by jv-datepicker="{saveFormat:'mm/dd/yy'}"
            var DEFAULT_SAVE_FORMAT = 'yy-mm-dd';
            //Format used to show datepickers selected date based on user preferences. This can be overwritten by jv-datepicker="{viewFormat:'mm/dd/yy'}"
            var DEFAULT_VIEW_FORMAT = $window._jvselfUser ? $window._jvselfUser.locale.userDate.shortDatePicker(): 'mm/dd/yy';
            
            //Over writing view format
            var userPreferredFormat = scope.$eval(iAttrs.jvLocaleDatepicker);
            DEFAULT_VIEW_FORMAT = (userPreferredFormat && userPreferredFormat.viewFormat) ? userPreferredFormat.viewFormat : DEFAULT_VIEW_FORMAT;
            //Over writing save format
            DEFAULT_SAVE_FORMAT = (userPreferredFormat && userPreferredFormat.saveFormat) ? userPreferredFormat.saveFormat : DEFAULT_SAVE_FORMAT;

            //get todays date in user timezone
            var getTodayDateUserTimezone = function() {
                var userTimeZone = _jvselfUser.locale.timezone;
                var todayDate = new Date( moment.tz(new Date(),userTimeZone).format('MM/DD/YYYY') );
                return todayDate;
            };
            //Setting the todays date in the datepicker based on users time zone
            /**
                @params 
                hasUserPaginated - has the user hit prev/next true false
            **/
            var  setTodaysDateInUserTimeZone = function(hasUserPaginated){
                //jvContextualLoadingService.show('date-picker');
                var todayDate = getTodayDateUserTimezone();
                scope.dateInUserTimeZone = todayDate.getDate();
                var timeout  = scope.multiSelect ? 500 : 50;
                //jv-locale-datepicker-disable-dates-by - to prompt the user to select dates only from a certain date-range
                var disableDatesBy = iAttrs.jvLocaleDatepickerDisableDatesBy;
                if(disableDatesBy){
                    /**
                        save the pre-populated value so the following scenario doesn't break
                        field has past date saved, now when user clicks on edit picker, the first date from
                        required date range shouldn't be pre populated unless the user selects a date from the picker
                    **/
                    var prepopulatedValue = $(iElm).val();
                }

                if(!scope.multiSelect){
                    //If user has paginated setDate else default date
                    if(!hasUserPaginated){
                        //load date picker the first time
                        $(iElm).datepicker( "option", "defaultDate", todayDate);
                    }else{
                        $(iElm).datepicker( "setDate", todayDate);
                        //making sure we dont change the pre-selected date value
                        $(iElm).val(ngModel.$viewValue);
                    }
                    //if the user has past dates disabled and past date saved, populate back the saved data
                    if(disableDatesBy){
                        $(iElm).datepicker( "option", "minDate", disableDatesBy);
                        $(iElm).val(prepopulatedValue);
                    }
                }
                //Timeout needed to make sure element is rendered before we do css manipulations
                  //commenting the below code to fix an enhancement for HIRE-8670
                /*$timeout(function(){
                    if( $('.ui-datepicker-today >.ui-state-highlight').length){
                        //Remove highlight class from todays date
                        $('.ui-datepicker-today >.ui-state-highlight').removeClass('ui-state-highlight');

                        var todayRenderedInCalendar = $('.ui-datepicker-today a');
                        var todayInUserTimeZone = $("a:contains("+scope.dateInUserTimeZone +").ui-state-hover");
                        
                        //Remove today class from todays date
                      
                        $(todayRenderedInCalendar).parent().removeClass('ui-datepicker-today');

                        //Add highlight class to todays date in usertimezone
                        $(todayInUserTimeZone).addClass('ui-state-highlight');
                        //Add highlight class to todays date td
                        $(todayInUserTimeZone).parent().addClass('ui-datepicker-today');
                    }
                    
                },timeout);*/
            };

            var onSelect = function(dates){
                scope.$apply(function() {
                    ngModel.$setViewValue(dates);
                });
            };
            
            var setLatestClickedDate = function(date){
                scope.$apply(function() {
                    var model = $parse(iAttrs.jvLocaleDatepickerJump);
                    model.assign(scope, date);
                });                    
            };

            var onChangeMonthYear = function(paginatedyear,paginatedMonth,inst){
                var todayDate = getTodayDateUserTimezone();
                var localMonth = todayDate.getMonth();
                var localYear = todayDate.getFullYear();
                /**
                if the field has past dates disable, don't make the paginatedMonth to 0 for the following reason
                e.g. user has Oct 9 selected, user paginates to Nov - when paginated back to Oct, date picker is hidden
                from UI, as based on the following calculation paginatedMonth will be 9 and date picker shouldb't allow past dates
                **/
                if(paginatedMonth !== 0 && !iAttrs.jvLocaleDatepickerDisableDatesBy){
                    //making the month zero based
                    paginatedMonth = paginatedMonth-1;
                }
                if(scope.multiSelect){
                    setTodaysDateInUserTimeZone(false);
                }else{
                    if( paginatedMonth === localMonth && localYear === paginatedyear){
                        setTodaysDateInUserTimeZone(true);
                    }
                }
            };

            var options = angular.extend({
                yearRange: "c-100:c+10",
                dateFormat: DEFAULT_VIEW_FORMAT,
                changeMonth: true,
                changeYear: true,
                //callback fired when user changes year/month
                onChangeMonthYear : function(paginatedyear,paginatedMonth,inst){
                    onChangeMonthYear(paginatedyear,paginatedMonth,inst);
                },
                beforeShow: function(input, inst) {
                    if (inst.settings.position == "right") {
                        inst.dpDiv.css({
                            marginTop: -input.offsetHeight + 'px',
                            marginLeft: input.offsetWidth + 'px'
                        });
                    } else if (inst.settings.position == "left-aligned") {
                        inst.dpDiv.css({
                            marginLeft: 0
                        });
                    }

                    //this class isn't removed for some reason so datepicker never becomes visible, need to manually remove it
                    if($('#ui-datepicker-div').length){
                        $('#ui-datepicker-div').removeClass('ui-helper-hidden-accessible');
                    }
                    setTodaysDateInUserTimeZone();
                },
                onSelect: function(date){
                    onSelect(date);
                }
            }, scope.$eval(iAttrs.jvLocaleDatepicker) || {});
            
            ngModel.$parsers.push(function(value){
                if (value && !options.multiSelect){
                    value  =  iElm.datepicker("getDate");
                    return $.datepicker.formatDate(DEFAULT_SAVE_FORMAT, value);
                }
                return value;
            });
            ngModel.$formatters.push(function(value) {
                if(value && !options.multiSelect){
                    try {
                        if (value === parseInt(value) || (angular.isString(value) && value.indexOf('T') === 10)) {
                            value = new Date(value);
                        } else if(!angular.isDate(value)){
                            value = $.datepicker.parseDate(DEFAULT_SAVE_FORMAT, value);
                        }
                        return $.datepicker.formatDate(DEFAULT_VIEW_FORMAT, value);
                    } catch(err) {
                        //value aka date is not in expected format
                        return;
                    }
                }
                return value;
            });

            //Multiselect datepicker
            if(options.multiSelect){
                scope.multiSelect = true;
                options.dateFormat = 'mm/dd/yy';
                setTodaysDateInUserTimeZone(false);
                $(iElm).multiDatesPicker({
                    numberOfMonths: options.numberOfMonths,
                    maxPicks: options.maxPicks,
                    dateFormat: options.dateFormat,
                    defaultDate:getTodayDateUserTimezone(),
                    //This is fired when a date is selected and based on the attribute it will either select and return value or save as array 
                    onSelect : function(date, inst){
                        setTodaysDateInUserTimeZone(false);
                        if(iAttrs.jvLocaleDatepickerJump){                            
                            // only if you want to return latest selected date
                            inst.dpDiv.find('a.ui-state-highlight').removeClass('ui-state-highlight');
                            setLatestClickedDate(date);
                        }else{            
                            // if you want a set of all dates
                            var datesPicked = $(iElm).multiDatesPicker('getDates');
                            onSelect(datesPicked);
                        }
                    },
                    onChangeMonthYear: function(paginatedyear,paginatedMonth,inst){
                        onChangeMonthYear(paginatedyear,paginatedMonth,inst);
                    }
                });
                
                //override min day names if there
                if(options.dayNamesMin){
                    $(iElm).datepicker("option", "dayNamesMin", options.dayNamesMin);
                }

                //override for showing other days in the months as disabled
                if(options.showOtherMonths){
                    $(iElm).datepicker("option", "showOtherMonths", true);
                    $(iElm).datepicker("option", "selectOtherMonths", false);
                }
            }else{
                //Render regular datepicker
                var keyUpCLearDate = function(e) {
                    if(e.keyCode === 8 || e.keyCode === 46) {
                        $.datepicker._clearDate(this);
                        document.getElementById(this.id).value = '';
                    }
                };
                if (parseFloat(jQuery.fn.jquery) >= 1.7) {
                    $(iElm).on('keyup', keyUpCLearDate);
                } else {
                    $(iElm).bind('keyup', keyUpCLearDate);
                }
                
                $(iElm).datepicker(options);
                scope.$watch(iAttrs.jvLocaleDatepicker, function(opts) {
                      $(iElm).datepicker('option', opts);
                }, true);
            }
        }
    };

}]);
